<template>
    <router-view></router-view>
</template>

<script>
  export default {
    created() {
      //在页面加载时读取sessionStorage里的状态信息
      if (this.$store.getters.currentUser == null) {
        if (sessionStorage.getItem("store") != null) {
          this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
        }
        // else {
        //   this.$router.push({path: "/login"})
        // }
      }

      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        if (this.$store.getters.currentUser != null) {
          sessionStorage.setItem("store", JSON.stringify(this.$store.state))
        } else {
          sessionStorage.clear()
          // this.$router.push({path: "/login"})
        }
      })
    }
  }
</script>

<style>

</style>
